import type { Enums } from "../types";

/**
 * This function returns the color associated with a given project invoice type.
 * @param type
 * @returns
 */
export function getProjectInvoiceTypeColor(type: Enums<"outgoingInvoiceType">): Enums<"color"> {
	switch (type) {
		case "final-invoice":
			return "emerald";
		case "progress-invoice":
			return "amber";
		case "single-invoice":
			return "blue";
	}
	return "gray";
}
